import { ChevronRightIcon } from "assets";
import { ShareModal } from "components/modal-variants/share-modal";
import { CreditIndicator } from "../credit-indicator";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "state/hooks";
import { useClickOutside } from "hooks";
import { useCredits } from "hooks/useCredits";
import { Routes } from "router";
import { Signout } from "pages";
import { CreditStatusModal } from "pages/pricing-v2/components/credit-status-modal";
import { BuyAdditionalCreditModal } from "pages/pricing-v2/components/buy-additional-credit-modal";

interface PageHeaderProps {
  title: string;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, className = '' }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showCreditStatusModal, setShowCreditStatusModal] = useState(false);
  const [showBuyCreditModal, setShowBuyCreditModal] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const profileDropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useClickOutside(profileDropdownRef, () => setShowProfileDropdown(false));
  const user = useAppSelector((state) => state.user);
  const { companyLogo, firstName, lastName } = user;

  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();

  const { balance } = useCredits();

  const handleCreditIndicatorClick = () => {
    setShowCreditStatusModal(true);
  };

  return (
    <>
      <header className={`lg:flex fixed top-0 z-[999] w-[calc(100%-250px)] hidden items-center justify-between px-[2.8%] py-5 bg-[#E8F3FF] ${className}`}>
        <h1 className="font-Gelion text-[20px] leading-[32px] font-normal text-[#012169]">
          {title}
        </h1>
        <div className="flex items-center justify-between gap-2 cursor-pointer">
          <CreditIndicator size={32} strokeWidth={4} onClick={handleCreditIndicatorClick} />
          <div className="relative" ref={profileDropdownRef}>
            <div
              className="flex items-center gap-1 cursor-pointer"
              onClick={() => setShowProfileDropdown(!showProfileDropdown)}
            >
              <div className="w-8 h-8 rounded-full overflow-hidden bg-white border border-gray-300 flex items-center justify-center">
                {companyLogo ? (
                  <img src={companyLogo} alt="User Avatar" className="w-full h-full object-contain" />
                ) : (
                  <span className="text-[#012169] font-semibold text-xs select-none">{initials}</span>
                )}
              </div>
              <ChevronRightIcon className={`w-[7px] ml-[2px] h-auto [&>path]:stroke-[#403DAA] [&>path]:stroke-[1px] transition-transform ${showProfileDropdown ? 'rotate-90' : '-rotate-90'}`} />
            </div>
            {showProfileDropdown && (
              <div className="absolute right-0 top-[calc(100%+8px)] bg-white rounded-xl shadow-lg border border-gray-100 py-2 min-w-[160px] z-[1000]">
                <button
                  className="w-full text-left px-4 py-2.5 text-sm text-[#1D2939] hover:bg-gray-50 transition-colors"
                  onClick={() => { setShowProfileDropdown(false); navigate(Routes.settings); }}
                >
                  View Profile
                </button>
                <button
                  className="w-full text-left px-4 py-2.5 text-sm text-[#1D2939] hover:bg-gray-50 transition-colors"
                  onClick={() => { setShowProfileDropdown(false); setShowLogout(true); }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
      <Signout show={showLogout} close={() => setShowLogout(false)} />
      <ShareModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <CreditStatusModal
        isOpen={showCreditStatusModal}
        onClose={() => setShowCreditStatusModal(false)}
        onTopupCredit={() => {
          setShowCreditStatusModal(false);
          setShowBuyCreditModal(true);
        }}
      />
      <BuyAdditionalCreditModal
        isOpen={showBuyCreditModal}
        onClose={() => setShowBuyCreditModal(false)}
        currentBalance={balance}
      />
    </>

  );
};

export { PageHeader };
